import { current } from "@reduxjs/toolkit";
import { Schedule } from "../../../../types/schedule/schedule";
import { ScheduleDto } from "../../../../types/schedule/schedule-dto";
import { convertScheduleDtoToSchedule } from "../../../../utils/converter/schedule/schedule-converter";
import { ScheduleState } from "../../../type/schedule-state";

interface Action {
  type: string;
  payload: {
    scheduleDto: ScheduleDto;
  };
}

export const setSchedulePageAllByDtoDispatch = (
  state: ScheduleState,
  action: Action
) => {
  const { scheduleDto } = action.payload;
  const schedule = convertScheduleDtoToSchedule(scheduleDto);
  const { currentDeliveryGroup } = schedule;

  try {
    if (currentDeliveryGroup.isWork && currentDeliveryGroup.isExpectedDelay) {
      const audio = document.getElementById(
        "warning-audio"
      ) as HTMLAudioElement | null;
      if (audio) {
        audio.play().catch(e => {});
      }
    }
  } catch (error) {
    console.log(error);
  }

  const index = state.schedulePageAll.contents.findIndex(
    (schedule: Schedule) => {
      return schedule.id === scheduleDto.id;
    }
  );

  if (index !== -1) {
    state.schedulePageAll.contents[index] = schedule;
  } else {
    state.schedulePageAll = {
      ...state.schedulePageAll,
      contents: [schedule, ...state.schedulePageAll.contents],
    };
  }
};
